export const PRISMIC_TYPES = {
  FAQ: 'faq',
  REGISTRATION_HOME_PAGE: 'registration_home_page',
}
